<template>
    <div class="contactUSDetails">
        <div class="contents">
            <div class="card" v-for="(cardMessage, index) in cardMessages" :key="index">
                <!-- <img class="card-img" src="https://demos.creative-tim.com/argon-design-system-pro/assets/img/ill/inn.svg" alt="Card image"> -->
                <span @click="deleteMessage(cardMessage._id)" class="deleteIcon">
                    <i class="fa fa-trash"></i>
                </span>
                <div class="card-img-overlay d-flex align-items-center">
                    <div class="content">
                        <h5 class="h2 card-title mb-2">{{ cardMessage.name }}</h5>
                        <h5 class="h2 card-title mb-2">{{ cardMessage.email }}</h5>
                        <h5 class="h2 card-title mb-2">{{ cardMessage.phone }}</h5>
                        <p class="card-description">{{ cardMessage.message }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import APIs from './../../../../config'
    export default {
        data(){
            return {
                cardMessages: "",

                get_token: localStorage.getItem('token'),
                user_id: localStorage.getItem('user_id'),
            }
        },
        props : {
            cardInfo : Object
        },
        created() {
            console.log("messages: ", this.cardInfo.generatedUrl)
            this.getCurrentData()
        },
        methods: {
            getCurrentData() {
                this.cardInfo

                axios.get(`${APIs.API_URL}/card/smartCardMessages/${this.cardInfo.generatedUrl}`)
                .then(res => {
                    this.cardMessages = res.data.cardMessage
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteMessage(id) {  
            this.$swal.fire({
            title: 'Are you sure you want to delete',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
            }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${APIs.API_URL}/contact/${id}`)
                .then(() => {
                    this.$swal.fire(
                    'Deleted',
                    '',
                    'success'
                    )
                })
                .then(() => {
                    this.getCurrentData()
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
            })
            }
        }
    }
</script>

<style scoped lang="scss">
                    ::-webkit-scrollbar {
                        width: 0px;
                    }
    .contactUSDetails {
        background-color: white;
        padding: 2% 6%;
        border-radius: 10px;
        margin: 0% 5%;
        .contents {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            .card {
                width: 40%;
                height: 300px;
                margin-bottom: 3%;
                .deleteIcon {
                    position: absolute;
                    right: 5%;
                    top: 5%;
                    cursor: pointer;
                    z-index: 1;
                    i {
                        color: red;
                        font-size: 24px;
                    }
                }
                .content {
                    margin-bottom: 3%;
                    height: 300px;
                    overflow-x: scroll;
                    padding: 15% 4%;
                    h5 {
                        font-size: 20px;
                        color: #344767;
                    }
                    p {
                        color: #344767;
                    }
                }
            }
        }
    }
</style>
